import { render, staticRenderFns } from "./CoursePrice.vue?vue&type=template&id=7866e3b6&scoped=true&"
import script from "./CoursePrice.vue?vue&type=script&lang=js&"
export * from "./CoursePrice.vue?vue&type=script&lang=js&"
import style0 from "./CoursePrice.vue?vue&type=style&index=0&id=7866e3b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7866e3b6",
  null
  
)

export default component.exports